import { useNavigate } from "react-router-dom";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuLinkItem,
} from "../components/ui/DropdownMenu";
import { QUICK_ACTIONS } from "./navConfig";

export function MenuBarQuickActionsMenu({
  onOpenCommandPalette,
  onOpenLayouts,
}: {
  onOpenCommandPalette: () => void;
  onOpenLayouts: () => void;
}) {
  const navigate = useNavigate();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger>Quick actions ▾</DropdownMenuTrigger>
      <DropdownMenuContent minWidth={220}>
        {QUICK_ACTIONS.map((action) => (
          <DropdownMenuLinkItem
            key={action.id}
            description={action.description}
            onNavigate={() => {
              if (action.onAction === "open-palette") onOpenCommandPalette();
              else if (action.onAction === "open-layouts") onOpenLayouts();
              else if (action.path) navigate(action.path);
            }}
          >
            {action.label}
          </DropdownMenuLinkItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
